// extracted by mini-css-extract-plugin
export default {"container":"ExceptionConfig_container__EYy2C","page-header":"ExceptionConfig_page-header__NcdrC","page-title":"ExceptionConfig_page-title__xpHAJ"};